module.exports = __webpack_public_path__ + "img/maneken_pos_7.bd95563a.png";